export default "__VITE_ASSET__COuVypWM__"